import React from 'react';
import { withTheme } from 'styled-components';
import { Svg, Path } from 'react-native-svg';

const Bin = ({ className = '', size = '24px', theme, color = theme.colors['Level 3'] }) => (
    <Svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <Path fillRule="evenodd" clipRule="evenodd" d="M9 10H11L11 18H9L9 10Z" fill={color} />
        <Path fillRule="evenodd" clipRule="evenodd" d="M13 18V10H15V18H13Z" fill={color} />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 6H21V8H19V19C19 20.6569 17.6569 22 16 22H8C6.34315 22 5 20.6569 5 19V8H3V6H8V5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V6ZM11 4C10.4477 4 10 4.44772 10 5V6H14V5C14 4.44772 13.5523 4 13 4H11ZM17 8H7V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V8Z"
            fill={color}
        />
    </Svg>
);

export default withTheme(Bin);
